import { TitanSprite } from "@lib/titan2/dist/game/control/TitanSprite";
import { CommonGameEvent } from "@lib/titan2/dist/game/controller/event/CommonGameEvent";
import { CommonLang } from "@lib/titan2/dist/game/view/lang/CommonLang";
import { KeyValuePair } from "@lib/titan2/dist/util/collection/KeyValuePair";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
import { ViewUtils } from "@lib/titan2/dist/util/view/ViewUtils";
import { Service } from "../../../../api/Service";
import { SlingoEvent } from "../../../controller/event/SlingoEvent";
import { SlingoLang } from "../lang/SlingoLang";
import { AbstractGameView } from "./AbstractGameView";
import { ArcadeWheelEvent } from "./ArcadeWheel";
/**
 * Navigation.ts
 */
export class Navigation extends AbstractGameView {
    createProperties(properties, portraitProperties) {
        super.createProperties(properties, portraitProperties);
        this.landscapeProperties = properties;
        this.portraitProperties = portraitProperties;
        this.uiProperties = this.uiProperties;
    }
    create() {
        super.create();
        this.createBackground();
        this.createBalance();
        this.createStake();
        this.createTotalStake();
    }
    postCreate() {
        super.postCreate();
        this.pivot.set(0, this.height);
        Logger.addObjectRef(this, "Navigation");
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(SlingoEvent.BALANCE_UPDATE, this.handleBalanceUpdate);
        this.registerGame(CommonGameEvent.INITIALISE, this.handleInitialise);
        this.registerCore(CommonGameEvent.BALANCE_UPDATED, this.handleBalanceUpdate);
        this.registerGame(CommonGameEvent.STAKE_UPDATED, this.handleStakeUpdated);
        this.registerGame(SlingoEvent.SPIN_RESULT, this.handleSpinResult);
        this.registerGame(ArcadeWheelEvent.STAKE_TO_SPIN_RESULT, this.handleSpinResult);
    }
    createBackground() {
        if (this.uiProperties.backgroundProperties) {
            this.background = TitanSprite.createSprite(this, "background", this.landscapeProperties.backgroundProperties, this.portraitProperties?.backgroundProperties);
            this.background.x = this.renderer.getViewport().width / 2;
        }
    }
    createBalance() {
        this.balanceField = ViewUtils.createField(this, "balance", this.landscapeProperties.balanceFieldProperties, this.portraitProperties?.balanceFieldProperties);
    }
    createStake() {
        this.stake = ViewUtils.createField(this, "stake", this.landscapeProperties.stakeProperties, this.portraitProperties?.stakeProperties);
    }
    createTotalStake() {
        this.totalStake = ViewUtils.createField(this, "totalStake", this.landscapeProperties.totalStakeProperties, this.portraitProperties?.totalStakeProperties);
    }
    handleInitialise() {
        this.handleBalanceUpdate();
        this.handleStakeUpdated();
    }
    handleBalanceUpdate() {
        this.updateBalance();
    }
    handleStakeUpdated() {
        let stake = this.model.getCurrentStake();
        let totalStake = this.model.getTotalStaked();
        if (totalStake > stake) {
            this.updateTotalStake();
        }
        else {
            let params = [new KeyValuePair(CommonLang.PARAM_AMOUNT, this.formatCurrency(stake))];
            let message = this.langManager.getLang(SlingoLang.BOTTOM_BAR_STAKE, params);
            this.stake.setText(message, true);
            this.stake.visible = true;
            this.totalStake.visible = false;
        }
    }
    handleSpinResult() {
        let state = this.model.getPreviousState();
        if (state.isPurchaseSpin() || Service.isReplay()) {
            this.updateTotalStake();
        }
    }
    updateTotalStake() {
        let totalStake = this.model.getTotalStaked();
        let params = [new KeyValuePair(CommonLang.PARAM_AMOUNT, this.formatCurrency(totalStake))];
        let message = this.langManager.getLang(SlingoLang.BOTTOM_BAR_TOTAL_STAKE, params);
        this.totalStake.setText(message, true);
        this.totalStake.visible = true;
        this.stake.visible = false;
    }
    updateBalance() {
        let amount = this.model.getBalance().getAmount();
        this.updateBalanceField(amount);
    }
    updateBalanceField(amount) {
        if (this.balanceField) {
            let params = [new KeyValuePair(CommonLang.PARAM_AMOUNT, this.formatCurrency(amount))];
            this.balanceField.setText(this.langManager.getLang(SlingoLang.BALANCE, params), true);
        }
    }
    handleResize(event) {
        const transFormedScale = this.getTransformedScale(this, this.scale);
        const renderView = this.renderer.getView();
        const renderWidth = parseInt(renderView.style.width, 10) || renderView.width;
        const renderHeight = parseInt(renderView.style.height, 10) || renderView.height;
        const distanceToBottom = renderHeight - this.background.getGlobalPosition().y;
        const distanceToLeft = 0 - this.stake.getGlobalPosition().x;
        const distanceToRight = renderWidth - this.balanceField.getGlobalPosition().x;
        //Frustratingly, you can't detect fullscreen if the game is in an iframe. The only solution is to force the offset at all times.
        const fullScreenOffset = this.uiProperties.fullScreenOffset; //document.fullscreenElement ? this.uiProperties.fullScreenOffset : 0;
        this.y += distanceToBottom / transFormedScale.y - this.background.height;
        this.stake.x += distanceToLeft / transFormedScale.x + this.uiProperties.fieldOffset + fullScreenOffset;
        this.totalStake.x = this.stake.x;
        this.balanceField.x += distanceToRight / transFormedScale.x - this.uiProperties.fieldOffset - fullScreenOffset;
        this.background.width = renderWidth / transFormedScale.x;
    }
    handleRotate(event) {
        super.handleRotate(event);
        this.uiProperties = this.uiProperties;
    }
}
//# sourceMappingURL=Navigation.js.map